import * as d3 from 'd3';
import { BarChartConfig } from '../data/BarChartConfig';
import { ChartData } from '../data/ChartData';
import { ChartRenderer } from './ChartRenderer';
import { RendererConfig } from './RendererConfig';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { ChartConfig } from '../data/ChartConfig';

export abstract class ColumnBarChartRenderer extends ChartRenderer {
  protected data: Array<Array<ChartData>> = [];
  protected ele?: HTMLElement;

  protected rendererConfig: RendererConfig;

  constructor(protected config: BarChartConfig) {
    super();

    this.rendererConfig = new RendererConfig(this.config);

    if (!this.config.value?.unit) {
      const value = (this.config.value = this.config.value || {});
      value.unit = MeasureUnitCode.PERCENT;
    }
  }

  public updateConfig(config: ChartConfig, updateData?: boolean) {
    super.updateConfig(config, updateData);
    this.rendererConfig = new RendererConfig(this.config);
  }

  protected createSvgElement(ele: HTMLElement): d3.Selection<SVGSVGElement, unknown, null, undefined> {
    return d3
      .select(ele)
      .append('svg')
      .attr('class', 'mnb-chart mnb-bar-chart bar-chart')
      .attr('width', '100%')
      .attr('height', '100%');
  }
}
